/* eslint-disable */
import React from "react";

const TracerResearchHeader = () => {
  return (
    <>
      <header className="relative z-20 mt-24 flex h-auto items-center md:items-end md:pt-0">
        <div className="container mx-auto flex w-full flex-col justify-center px-4 text-center lg:px-0">
          <h1 className="mb-1 text-2xl font-black text-white transition-all duration-500 md:mb-3 md:text-[40px]">
            Tracer Research
          </h1>
          <small className="text-lg font-normal text-white transition-all duration-500 md:text-xl">
            Gain a more in-depth understanding of the Tracer
            <br /> Protocol and its capabilities.
          </small>
        </div>
      </header>
    </>
  );
};

export default TracerResearchHeader;
